import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type FloatingPageSectionProps = {
  /** Page chrome (e.g. `PageHeader` with leading + title). */
  header: ReactNode
  children: ReactNode
  className?: string
  panelClassName?: string
}

/**
 * Frosted HUD for page chrome + toolbar over a full-bleed canvas.
 * Outer padding reveals the canvas around the card (Memories graph, etc.).
 */
export function FloatingPageSection({
  header,
  children,
  className,
  panelClassName,
}: FloatingPageSectionProps) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-x-0 top-0 z-20',
        'p-3 sm:p-4 @3card:px-[60px]',
        className,
      )}
    >
      <div
        className={cn(
          'pointer-events-auto flex flex-col gap-0 rounded-lg border border-border/40 bg-background/85 p-3 shadow-sm backdrop-blur',
          'supports-[backdrop-filter]:bg-background/70',
          'max-h-[40vh] overflow-y-auto',
          panelClassName,
        )}
      >
        {header}
        {children}
      </div>
    </div>
  )
}
